import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconShared = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M19.52 1.923c-5.817.633-10.33 5.1-11.014 10.904-.106.901-.041 2.694.131 3.621.898 4.828 4.672 8.716 9.498 9.783l.521.115-.544.08c-4.698.691-8.986 3.096-11.917 6.685-2.753 3.371-4.242 7.377-4.295 11.554-.011.862 0 .961.14 1.272.2.44.73.928 1.167 1.073.438.146 1.201.105 1.561-.082.356-.186.767-.628.936-1.008.115-.26.151-.5.192-1.28.11-2.103.476-3.712 1.26-5.525 1.042-2.41 3.016-4.777 5.228-6.27 3.2-2.157 7.101-3.005 10.848-2.356 2.594.449 4.462 1.292 6.966 3.146.553.409.843.501 1.45.462.745-.048 1.292-.413 1.629-1.087.168-.337.194-.457.19-.876-.008-.814-.244-1.216-1.098-1.876-2.683-2.07-5.55-3.298-8.875-3.8l-.73-.11.59-.12c2.176-.44 4.421-1.663 6.074-3.308 3.74-3.725 4.705-9.44 2.386-14.13-1.803-3.648-5.145-6.119-9.158-6.773-.756-.123-2.413-.173-3.136-.094m-.041 4.061c-2.055.322-4.094 1.542-5.347 3.2-1.923 2.543-2.207 6.055-.717 8.861a8.38 8.38 0 0 0 5.66 4.27c.417.09.813.116 1.725.114 1.023-.002 1.267-.022 1.792-.152 2.012-.498 3.654-1.578 4.847-3.187 2.048-2.762 2.14-6.567.23-9.472-.668-1.017-1.82-2.09-2.878-2.681-1.55-.867-3.558-1.227-5.312-.953m34.249 22.183c-3.35.33-6.087 2.845-6.727 6.183-.147.766-.136 2.162.023 2.913l.119.558-3.057 1.833-3.057 1.833-.305-.268c-.453-.399-1.09-.804-1.76-1.12-4.48-2.114-9.79.614-10.71 5.504-.126.662-.143 1.958-.037 2.599.382 2.286 1.714 4.218 3.726 5.401 2.214 1.302 5.165 1.348 7.417.115.855-.468 1.72-1.172 2.238-1.822l.236-.295 2.523 1.009 2.523 1.009.008.855c.004.502.052 1.09.116 1.427a7.66 7.66 0 0 0 3.795 5.262c2.889 1.615 6.534 1.155 8.94-1.13 2.526-2.4 3.114-6.212 1.424-9.234a7.67 7.67 0 0 0-5.262-3.795c-.753-.144-2.052-.145-2.799-.002-1.705.325-3.34 1.27-4.398 2.54l-.3.36-2.522-1.01-2.522-1.009.021-.501c.025-.575-.079-1.626-.208-2.113l-.087-.331 3.067-1.84 3.067-1.838.174.16c.65.6 1.745 1.241 2.638 1.544a7.64 7.64 0 0 0 7.706-1.683c2.527-2.4 3.115-6.212 1.425-9.234a7.64 7.64 0 0 0-4.331-3.552 7.8 7.8 0 0 0-3.104-.328m-.032 4.061c-.675.146-1.188.437-1.733.983-.946.945-1.281 2.153-.954 3.433.322 1.26 1.396 2.327 2.638 2.62a3.59 3.59 0 0 0 3.396-.973c1.107-1.107 1.378-2.697.703-4.115-.299-.628-1.015-1.36-1.618-1.654a3.72 3.72 0 0 0-2.432-.294m-18.83 11.263c-.92.223-1.93 1.036-2.344 1.885a3.7 3.7 0 0 0 .001 3.264c.276.562 1.027 1.313 1.59 1.589a3.7 3.7 0 0 0 3.263.001c.603-.294 1.319-1.026 1.618-1.654 1.156-2.428-.603-5.202-3.282-5.178a4.6 4.6 0 0 0-.846.093m18.83 7.49c-.674.145-1.188.436-1.734.981-.939.938-1.28 2.158-.955 3.425.177.693.404 1.082.96 1.644.911.921 2.056 1.26 3.337.989.657-.14 1.174-.435 1.727-.989.554-.553.85-1.07.989-1.727.271-1.281-.068-2.426-.99-3.337-.561-.556-.95-.783-1.643-.96a3.5 3.5 0 0 0-1.691-.027" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconShared.displayName = 'IconShared';